<script>
import chroma from 'chroma-js'

export default {
  name: 'Input',
  props: {
    label: { type: String, required: true },
    placeholder: { type: String, default: '' },
    area: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    error: { type: String, default: '' },
    value: { type: String, required: true },
    labelColor: { type: String, default: '' },
    borderColor: { type: String, default: '' },
    errorColor: { type: String, default: '' },
    scale: { type: Number, default: 1 }
  },
  computed: {
    _class () {
      return `input ${this.error ? 'error' : ''}`
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    cssVariables () {
      return {
        '--scale': this.scale,
        '--label-color': this.labelColor || 'var(--on-background)',
        '--error-override-color': this.errorColor,
        '--error-shadow': chroma(this.errorColor || this.wl.colors.error || 'red').darken().alpha(0.5),
        '--border-color': this.borderColor
      }
    }
  }
}
</script>

<template>
  <div
    class="input-container"
    :style="cssVariables"
  >
    <label
      v-html="label"
    />
    <span v-if="area">
      <textarea
        v-model="_value"
        :class="`${_class} area`"
        :placeholder="placeholder"
      />
      <div
        class="text-error"
      >
        <span
          v-if="error"
          v-html="error"
        />
      </div>
    </span>
    <span v-else>
      <input
        v-model="_value"
        :type="type"
        :class="_class"
        :placeholder="placeholder"
      >
      <div
        class="text-error"
      >
        <span
          v-if="error"
          v-html="error"
        />
      </div>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.input-container {
  width: 100%;
  label {
    color: var(--label-color);
    display: block;
    font-weight: 600;
    margin: calc(3px * var(--scale)) 0;
    font-size: calc(16px * var(--scale));
  }
  .text-error {
    color: var(--error-override-color, var(--error));
    font-size: calc(14px * var(--scale));
    margin-left: calc(10px * var(--scale));
    height: calc(20px * var(--scale));
  }
  .input {
    width: 100%;
    background-color: var(--surface-light);
    color: var(--on-surface-light);
    height: calc(45px * var(--scale));
    border: 1px solid var(--border-color);
    border-radius: calc(8px * var(--scale));
    font-size: calc(18px * var(--scale));
    padding: 0 calc(15px * var(--scale));
    box-sizing: border-box;
    &.error {
      border: 1px solid var(--error);
      color: var(--error);
      box-shadow: inset 2px 3px 4px 0 var(--error-shadow);
    }
    box-shadow: inset 2px 3px 4px 0 rgba(49, 36, 36, 0.25);
    &.area {
      padding-top: calc(15px * var(--scale));
      min-height: calc(193px * var(--scale));
      resize: none;
    }
    &:focus {
      outline: 0;
    }
  }
}
</style>
